import { PlanoProduto } from '@/types/produto';
import * as S from './styles';
import GiftCard from '../GiftCard';
import useBreakpoint from '@/hooks/useBreakpoint';

export type GiftCardValoresGridProps = {
  $planos: Array<PlanoProduto>;
  $planoSelecionado: number;
  $selecionarValor: (index: number) => void;
};

export default function GiftCardValoresGrid(props: GiftCardValoresGridProps) {
  const { $planos, $planoSelecionado, $selecionarValor } = props;
  const count = $planos.length;
  const { breakpoint } = useBreakpoint();

  return (
    <S.GridWrapper $itemCount={count} $breakpoint={breakpoint}>
      {$planos.map((item, index) => {
        const ultimoItemCentralizado = count % 2 !== 0 && index === count - 1;

        return (
          <S.GridItem
            key={index}
            $ultimoItemCentralizado={ultimoItemCentralizado}
          >
            <GiftCard
              $selecionado={$planoSelecionado === index}
              $giftCard={item}
              $onClick={() => $selecionarValor(index)}
            />
          </S.GridItem>
        );
      })}
    </S.GridWrapper>
  );
}
